/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedVentureFundDividendRequestDto } from '../../models/backend-patched-venture-fund-dividend-request-dto';
import { BackendVentureFundDividendDto } from '../../models/backend-venture-fund-dividend-dto';

export interface VentureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedVentureFundDividendRequestDto;
}

export function ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded.PATH,
    'patch',
  );
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDividendDto>;
    }),
  );
}

ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded.PATH =
  '/api/venture_funds/venture-fund-dividends/{id}/';
